import { jwtDecode } from 'jwt-decode';

export function getUserIdFromToken() {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
        const decoded = jwtDecode(token);
        return decoded.id || decoded.sub || decoded.user_id || null;
    } catch (err) {
        console.error('Erro ao decodificar token:', err);
        return null;
    }
}

export function getAuthHeaders() {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
}
